import { PublicClientApplication } from '@azure/msal-browser';

export const ACCESS_TOKEN_LOCAL_STORAGE_KEY = 'azure_token';

export const azureClientId = process.env.REACT_APP_AZURE_CLIENT_ID;
export const azureTenantId = process.env.REACT_APP_AZURE_TENANT_ID;

export const msalConfig = {
  auth: {
    clientId: azureClientId,
    authority: `https://login.microsoftonline.com/${azureTenantId}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: [
    'openid',
    'profile',
    'email',
    `api://${azureClientId}/access_as_user`,
  ],
};

export const roleDisplayNames = {
  time_operations: 'Operations',
  time_user: 'User',
  time_admin: 'Admin',
};

// Initialize MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize the client application
(async () => {
  await msalInstance.initialize();
})();
